import { render } from "./gabon-menu.vue?vue&type=template&id=acea2f44&scoped=true"
import script from "./gabon-menu.vue?vue&type=script&lang=js"
export * from "./gabon-menu.vue?vue&type=script&lang=js"

import "./gabon-menu.vue?vue&type=style&index=0&id=acea2f44&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acea2f44"]])

export default __exports__